/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Injury_Note_Too_LongInputs */

const en_us2_injury_note_too_long = /** @type {(inputs: Injury_Note_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keep the note to ${i?.max} characters or fewer.`)
};

const pt_br2_injury_note_too_long = /** @type {(inputs: Injury_Note_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A anotação pode ter no máximo ${i?.max} caracteres.`)
};

const es_419_injury_note_too_long = /** @type {(inputs: Injury_Note_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La nota puede tener como máximo ${i?.max} caracteres.`)
};

const pt_pt2_injury_note_too_long = /** @type {(inputs: Injury_Note_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A nota pode ter no máximo ${i?.max} caracteres.`)
};

const fr_fr2_injury_note_too_long = /** @type {(inputs: Injury_Note_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La note ne peut pas dépasser ${i?.max} caractères.`)
};

const de_de2_injury_note_too_long = /** @type {(inputs: Injury_Note_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Notiz darf höchstens ${i?.max} Zeichen haben.`)
};

const it_it2_injury_note_too_long = /** @type {(inputs: Injury_Note_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La nota può avere al massimo ${i?.max} caratteri.`)
};

/**
* | output |
* | --- |
* | "Keep the note to {max} characters or fewer." |
*
* @param {Injury_Note_Too_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const injury_note_too_long = /** @type {((inputs: Injury_Note_Too_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Note_Too_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_injury_note_too_long(inputs)
	if (locale === "es-419") return es_419_injury_note_too_long(inputs)
	if (locale === "pt-PT") return pt_pt2_injury_note_too_long(inputs)
	if (locale === "fr-FR") return fr_fr2_injury_note_too_long(inputs)
	if (locale === "de-DE") return de_de2_injury_note_too_long(inputs)
	if (locale === "it-IT") return it_it2_injury_note_too_long(inputs)
	return en_us2_injury_note_too_long(inputs)
});
export { injury_note_too_long as "injury.note_too_long" }